/* Copyright (C) nexleader - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written for nexleader <myipsat.com>, 2016-2018
 */

/*global angular*/
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NexleaderSessionComponent } from '../../../views/session/session.component';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-nexleader-new-session-modal',
  standalone: true,
  imports: [CommonModule, NexleaderSessionComponent],
  templateUrl: './new-session-modal.component.html',
})
export class NexleaderNewSessionModalComponent {
  group?: any;
  coach?: any;
  routeParams: any;

  constructor(private bsModalService: BsModalService) { }

  close() {
    this.bsModalService.hide();
  }
}
